import styled from "styled-components";

export const BaseLoginFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 60px 30px 0;
  max-width: 600px;
  min-width: 320px;
  margin: 0 auto;
`;

const LogoContainer = styled.div`
  width: 60%;
  margin: 30px auto 0;
  min-width: 156px;
  max-height: 60px;
  img {
    width: 100%;
    height: 100%;
  }
`;

export const TelusLogoContainer = styled(LogoContainer)`
  max-width: 322px;
`;

export const KoodoLogoContainer = styled(LogoContainer)`
  max-width: 211px;
`;

export const AvsLoginBadge = styled.img`
  display: block;
  margin: 5px auto 0;
`;

export const BaseLoginInstructions = styled.p`
  margin: 0;
`;

export const LoginInstructions = styled(BaseLoginInstructions)`
  margin: 10px 0;
  font-size: ${({ theme }) => theme.typography.mediumSwimlaneFontSize};
  font-weight: bold;
`;

export const BaseForm = styled.form`
  display: flex;
  flex-direction: column;
`;

export const BaseTextInput = styled.input.attrs(({ type }) => ({
  type: type ?? "text",
}))`
  border: 0;
  border-radius: 6px;
  background-color: ${({ theme }) => theme.colours.textInputBackground};
  color: ${({ theme }) => theme.colours.white};
  font-family: ${({ theme }) => theme.typography.regularFontFamily};
  font-size: ${({ theme }) => theme.typography.mediumFontSize};

  &::placeholder {
    color: ${({ theme }) => theme.colours.textInputPlaceholder};
  }

  margin: 5px 0;
  padding: 15px;
`;

export const BasePasswordWrapper = styled.div`
  display: flex;
  margin: 5px 0;
  align-items: center;
  position: relative;
`;

export const BasePasswordInput = styled(BaseTextInput).attrs(({ $isPasswordVisible }) => ({
  type: $isPasswordVisible ? "text" : "password",
}))`
  width: 100%;
  border-radius: 6px;
  padding-right: 58px; /* Make space for the reveal button */
`;

export const BaseRevealPasswordButton = styled.button.attrs({
  type: "button",
})`
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 58px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  border-radius: 0;
  cursor: pointer;
  z-index: 2;

  svg {
    color: ${(props) => props.theme.colours.offWhite};
  }
`;

export const BaseSubmitButton = styled.button.attrs({
  type: "submit",
})`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0;
  border-radius: 8px;
  background: ${({ theme }) => theme.colours.buttonBackground};
  color: ${({ theme }) => theme.colours.white};
  font-family: ${({ theme }) => theme.typography.regularFontFamily};
  font-size: ${({ theme }) => theme.typography.mediumFontSize};
  line-height: 135%;
  align-self: center;
  width: 100%;
  padding: 10px;
  margin-top: 15px;
  cursor: pointer;
  font-weight: bold;

  &:hover {
    outline: 0;
    background: ${({ theme }) => theme.colours.subscribeLink};
    color: ${({ theme }) => theme.colours.white};
  }
`;

export const BaseErrorMessageContainer = styled.div`
  background-color: ${({ theme }) => theme.colours.recordingButtonBackground};
  font-size: ${({ theme }) => theme.typography.smallFontSwimlane};
  line-height: 23px;
  margin: 5px 0;
  padding: 14px 16px;
  border-radius: 8px;
  font-weight: bold;

  .error-icon {
    width: 24px;
    margin-right: 8px;
    float: left;
  }
`;

export const SwitchLoginContainer = styled.div`
  margin: 32px auto 0;
  max-width: 600px;
  overflow: hidden;

  & > span {
    display: block;
    text-align: center;
    font-size: ${({ theme }) => theme.typography.smallFontSwimlane};
    color: ${({ theme }) => theme.colours.offWhite};

    &:before,
    &:after {
      content: "";
      display: inline-block;
      width: 50%;
      height: 1px;
      background-color: ${({ theme }) => theme.colours.greyLight};
      vertical-align: middle;
      position: relative;
    }

    &:before {
      margin-left: -50%;
      right: 26px;
    }
    &:after {
      margin-right: -50%;
      left: 26px;
    }
  }
`;

export const SwitchLoginButton = styled.button.attrs({
  type: "button",
})`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 32px;
  background-color: ${({ theme }) => theme.colours.recordingButtonBackground};
  color: ${({ theme }) => theme.colours.white};
  text-decoration: none;
  font-size: ${({ theme }) => theme.typography.smallFontSwimlane};
  font-weight: 600;
  line-height: 135%;
  border-radius: 8px;
  padding: 11.5px 0;
  cursor: pointer;
  width: 100%;
  border: none;

  &:hover {
    outline: 0;
    background: ${({ theme }) => theme.colours.greyExtraLight};
  }

  img {
    width: fit-content;
    height: 24px;
  }

  hr {
    margin: 0 16px;
    width: 1px;
    height: 27px;
    border: 0;
    background-color: ${({ theme }) => theme.colours.white};
    opacity: 0.4;
  }

  span {
    height: 27px;
    line-height: 27px;
  }
`;
